import { render, staticRenderFns } from "./widgetFwSummary.vue?vue&type=template&id=0613d9f0&scoped=true&"
import script from "./widgetFwSummary.vue?vue&type=script&lang=js&"
export * from "./widgetFwSummary.vue?vue&type=script&lang=js&"
import style0 from "./widgetFwSummary.vue?vue&type=style&index=0&id=0613d9f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613d9f0",
  null
  
)

export default component.exports